/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Live_BodyInputs */

const en_us2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue or finish the current workout before starting another.`)
};

const pt_br2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue ou termine o treino atual antes de começar outro.`)
};

const es_419_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continúa o termina el entrenamiento actual antes de empezar otro.`)
};

const pt_pt2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua ou termina o treino atual antes de começar outro.`)
};

const fr_fr2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue ou termine la séance en cours avant d'en commencer une autre.`)
};

const de_de2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setz das aktuelle Training fort oder beende es, bevor du ein neues startest.`)
};

const it_it2_quick_workout_live_body = /** @type {(inputs: Quick_Workout_Live_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua o termina l'allenamento in corso prima di iniziarne un altro.`)
};

/**
* | output |
* | --- |
* | "Continue or finish the current workout before starting another." |
*
* @param {Quick_Workout_Live_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_live_body = /** @type {((inputs?: Quick_Workout_Live_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Live_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_live_body(inputs)
	if (locale === "es-419") return es_419_quick_workout_live_body(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_live_body(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_live_body(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_live_body(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_live_body(inputs)
	return en_us2_quick_workout_live_body(inputs)
});
export { quick_workout_live_body as "quick-workout.live_body" }